import { styled } from '@mui/system';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { appColors } from '../../../../utils/theme';

/** Own components */
export const ItemsButton = styled(Button)({
  fontSize: '14px',
  fontWeight: '400',
  fontFamily: 'Inter',
  color: '#68717A',
  borderRadius: '16px',
  background: '#fff !important',
  height: '29px',
  border: '2px solid #CED4DA',
  textTransform: 'capitalize',
  whiteSpace: 'nowrap',
  cursor: 'default'
});

/** Own clasess */
export const ChatStyle = makeStyles(() => ({
  dot: {
    backgroundColor: '#5f6368',
    display: 'inline-block',
    height: '4px',
    width: '4px',
    borderRadius: '50%',
    marginBottom: '3px',
    marginRight: '3px'
  },

  StartOfChat: {
    fontSize: '8px !important',
    color: '#FDFDFD !important',
    backgroundColor: '#0F0F0F !important',
    borderRadius: '20px',
    border: '1px solid #2A2A2A !important',
    padding: '3px 5px',
    lineHeight: '8px !important',
    fontFamily: 'Inter, sans-serif !important',
    fontWeight: '700 !important'
  },

  /** Sidebar */
  container: {
    backgroundColor: appColors.white,
    minWidth: '350px',
    maxWidth: '350px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    borderRight: `1px solid ${appColors.gray1}`
  },
  chatTypeTabsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    borderBottom: `1px solid ${appColors.gray1}`,
    paddingTop: 1
  },
  TabsText: {
    color: '#68717A',
    fontSize: '16px',
    fontWeight: 600
  },
  chatPersonWrapper: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.1)'
    }
  },
  activeKeyWrapper: {
    backgroundColor: 'rgba(0,0,0,0.1)'
  },
  ChatPersonWrapperBox: {
    padding: 20,
    display: 'flex',
    borderBottom: `1px solid ${appColors.gray1}`,
  },
  activeChatPersonWrapper: {
    backgroundColor: appColors.blue1
  },
  /** Main Body */
  chatWrapper: {
    height: '100%',
    padding: '20px',
    backgroundColor: '#F9FAFC'
  },
  chatWrapperBody: {
    height: '100%',
    // padding: 5,
    backgroundColor: appColors.white,
    borderRadius: 8,
    border: `1px solid ${appColors.gray1}`
  },
  headerContainer: {
    borderBottom: `1px solid ${appColors.gray1}`,
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  chatContent: {
    height: '100%',
    width: '100% !important',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  chatArea: {
    padding: '20px'
  },
  chatTextBox: {
    position: 'relative',
    border: `2px solid rgba(222, 226, 230, 1);`,
    borderRadius: 8,
  },
  chatProperties: {
    width: '100%',
    ':hover': {
      backgroundColor: '#f5faf6'
    },
    padding: '8px 10px'
  },
  /** Chat Profile */
  chatProfileBox: {
    flexGrow: 1,
    bgcolor: appColors.white,
    borderRadius: 8,
    border: '1px solid white',
    margin: '0px 16px'
  },
  profileBoxHeading: {
    fontSize: '16px',
    fontWeight: '600 !important',
    fontFamily: 'Inter !important',
    color: 'white'
  },
  profileBoxHeading2: {
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Inter',
    color: 'white'
  },
  profileBoxItalic: {
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: '14px',
    color: '#68717A',
    fontStyle: 'italic'
  },
  chatProfileName: {
    fontSize: '16px',
    color: 'white',
    fontFamily: 'Inter',
    fontWeight: 600
  },
  memberCommonText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  memberCircleImage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50px',
    height: '50px',
    position: 'relative'
  },
  memberCircleInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50px',
    height: '50px',
    background: '#fff',
    borderRadius: '50%'
  },
  membersNameText: {
    fontSize: '16px !important',
    fontFamily: 'Inter !important',
    fontWeight: '600 !important',
    color: 'white',
    marginRight: '10px !important'
  },
  membersButton: {
    borderRadius: '5px',
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: '600',
    width: '62px',
    height: '24px'
  },
  menberDetailsText: {
    fontSize: '14px !important',
    fontWeight: '400 !important',
    fontFamily: 'Inter !important',
    color: '#68717A !important'
  },
  memberChatBttn: {
    fontSize: '14px !important',
    fontWeight: '600 !important',
    fontFamily: 'Inter !important',
    color: '#0071A9 !important',
    border: '1px solid #0071A9 !important',
    borderRadius: '29px !important'
  },
  memberHelpBtn: {
    fontSize: '13px !important',
    fontWeight: '400 !important',
    fontFamily: 'Inter !important',
    color: '#68717A !important',
    border: '1px solid  #CED4DA !important',
    borderRadius: '29px !important',
    height: '29px',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap'
  },
  priorHelpBtn: {
    fontSize: '13px !important',
    fontWeight: '400 !important',
    fontFamily: 'Inter !important',
    color: '#fff !important',
    borderRadius: '16px !important',
    background: '#0071A9 !important',
    height: '29px',
    textTransform: 'capitalize',
    whiteSpace: 'nowrap'
  },
  memberBoxSize: {
    background: '#fff',
    borderRadius: '8px',
    border: '1px solid #EFF0F4',
    margin: '16px 16px 16px 0'
  },
  memberWorkHistory: {
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '22px',
    color: ' #68717A',
    fontStyle: 'italic'
  },
  memberLanguage: {
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: '12px',
    color: 'white'
  },
  filterAccordionDetails: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '5px'
  },
  filterDetailsText: {
    FontFamily: 'Inter',
    fontWeight: '400!important',
    fontSize: '14px !important',
    color: '#68717A'
  },
  programPopupWrapper: {
    color: '#68717A',
    fontSize: '14px',
    fontFamily: 'Inter',
    fontWeigth: '400',
    marginBottom: '10px'
  },
  popupSummary: {
    FontFamily: 'Inter',
    fontWeight: '600 !important',
    fontSize: '16px !important',
    color: ' white'
  },
  fileTypePDf: {
    width: '500',
    height: '300'
  },
  fileTypeImage: {
    width: '400px'
  },
  fileTypeVideo: {
    width: '500',
    height: '300'
  },
  fileUploadInput: {
    display: 'none'
  },
  featuredImage: {
    maxWidth: '100%',
    width: '200px',
    height: '200px'
  },
  displayFlex: {
    display: 'flex !important'
  },
  overflowHidden: {
    overflow: 'hidden!important'
  },
  flexDirectionColumn: {
    flexDirection: 'column'
  },
  flexDirectionColumnReverse: {
    flexDirection: 'column-reverse'
  },
}));
